import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import * as nyc from 'ui-library/NYC';

export interface SettingsPageContainerProps {
  onClickTitle: () => void;
  title: string;
  toolbar?: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
}

/*
 * Container component for settings pages that handles consistent spacing and alignment.
 */
const SettingsPageContainer = ({
  children,
  onClickTitle,
  subtitle = '',
  title,
  toolbar,
}: SettingsPageContainerProps): JSX.Element => (
  <nyc.Container
    size="md"
    className="settingsPageContainer-scrollContainer"
    dataTestAttrs={{component: 'settingsPageContainer', element: 'root'}}
  >
    <nyc.Row className="u-large-spacing-top u-small-spacing-bottom">
      <nyc.Col md={1} />
      <nyc.Col md={14}>
        <nyc.Row className="settingsPageContainer-header u-lr-split">
          <div {...getTestProps({component: 'settingsPageContainer', element: 'headerText'})}>
            <div>
              <span
                className="settingsPageContainer-banner"
                onClick={onClickTitle}
                {...getTestProps({component: 'settingsPageContainer', element: 'titleBanner'})}
              >
                {title} /
              </span>
            </div>
            <div>
              <div
                className="legacy-font-proxima-17"
                {...getTestProps({component: 'settingsPageContainer', element: 'subtitleText'})}
              >
                {subtitle}
              </div>
            </div>
          </div>
          <div>{toolbar}</div>
        </nyc.Row>
        <nyc.Row>{children}</nyc.Row>
      </nyc.Col>
    </nyc.Row>
  </nyc.Container>
);

export default SettingsPageContainer;
